export default {"src":"/_next/static/media/404.331a07e4.gif","height":94,"width":150,"blurWidth":0,"blurHeight":0};